import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Button, Typography, Chip, Skeleton, TextField } from '@mui/material';

// Modal genérico de "ver detalhes" do agendamento (filtros, membros de equipe/perfil/lista, destinatários).
// rows: [{ key, primary, secondary?, chips?: [string], badge?: { label, color, bg }, onClick? }]
class DetailsDialog extends Component {
  constructor(props) {
    super(props);
    this.state = { search: '' };
  }

  render() {
    const { intl, open, onClose, title, subtitle, loading, rows = [], emptyText, footer, searchable } = this.props;
    const q = this.state.search.trim().toLowerCase();
    const visible = q ? rows.filter(r => `${r.primary} ${r.secondary || ''} ${(r.chips || []).join(' ')}`.toLowerCase().includes(q)) : rows;

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { maxHeight: '90vh', borderRadius: 3 } }}>
        <DialogTitle sx={{ pb: 1 }}>
          <Typography sx={{ fontSize: 18, fontWeight: 700 }}>{title}</Typography>
          {subtitle && <Typography sx={{ fontSize: 13, color: '#888' }}>{subtitle}</Typography>}
          {searchable && !loading && rows.length > 8 && (
            <TextField fullWidth size="small" sx={{ mt: 1.5 }} placeholder={intl.formatMessage({ id: 'report.schedule.details.search' })}
              value={this.state.search} onChange={e => this.setState({ search: e.target.value })} />
          )}
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '8px 20px' }}>
            {loading ? [1, 2, 3, 4].map(i => <Skeleton key={i} variant="rounded" height={42} animation="wave" sx={{ my: 1 }} />)
              : visible.length === 0 ? (
                <Typography sx={{ fontSize: 14, color: '#888', textAlign: 'center', py: 4 }}>{emptyText || intl.formatMessage({ id: 'report.schedule.details.empty' })}</Typography>
              ) : visible.map(r => (
                <Box key={r.key} onClick={r.onClick} sx={{
                  display: 'flex', alignItems: 'flex-start', gap: 2, py: 1.2, borderBottom: '1px solid #f0f0f0',
                  cursor: r.onClick ? 'pointer' : 'default', '&:hover': r.onClick ? { backgroundColor: '#fafafa' } : undefined,
                }}>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#333' }}>{r.primary}</Typography>
                    {r.secondary && <Typography sx={{ fontSize: 12, color: '#888', wordBreak: 'break-all' }}>{r.secondary}</Typography>}
                    {r.chips && r.chips.length > 0 && (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.6, mt: 0.6 }}>
                        {r.chips.map((c, i) => <Chip key={`${c}-${i}`} size="small" variant="outlined" label={c} sx={{ borderColor: '#d6d6d6' }} />)}
                      </Box>
                    )}
                  </Box>
                  {r.badge && <Chip size="small" label={r.badge.label} sx={{ backgroundColor: r.badge.bg, color: r.badge.color, fontWeight: 600, flexShrink: 0 }} />}
                </Box>
              ))}
          </div>
        </DialogContent>
        <DialogActions sx={{ justifyContent: footer ? 'space-between' : 'flex-end', px: 2.5 }}>
          {footer && <Typography sx={{ fontSize: 12, color: '#888' }}>{footer}</Typography>}
          <Button onClick={onClose} sx={{ textTransform: 'none' }}>{intl.formatMessage({ id: 'report.schedule.close' })}</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default injectIntl(DetailsDialog);

// ----- builders compartilhados (dialog do assistente + página de gestão) -----

export const ELIGIBILITY_BADGE = {
  ok: { color: '#5b9b1e', bg: '#eef7e3' },
  no_email: { color: '#b9770e', bg: '#fff4e5' },
  domain_blocked: { color: '#c62828', bg: '#fdecea' },
};

// Linhas de filtros (resultado de ReportScheduleService.describeFilters).
export const buildFilterRows = (intl, filters) => filters.map(f => ({
  key: f.param,
  primary: f.labelId ? intl.formatMessage({ id: f.labelId }) : f.label,
  chips: f.valueId ? [intl.formatMessage({ id: f.valueId })] : f.values,
}));

// Linhas de membros (resultado de ReportScheduleService.getRecipientMembers).
export const buildMemberRows = (intl, members) => members.map((m, i) => ({
  key: `${m.email || m.phone}-${i}`,
  primary: m.name,
  secondary: [m.email, m.phone].filter(Boolean).join(' · ') || null,
  badge: { ...ELIGIBILITY_BADGE[m.eligibility], label: intl.formatMessage({ id: `report.schedule.eligibility.${m.eligibility}` }) },
}));

// Footer "X de Y receberão" para membros.
export const buildMembersFooter = (intl, members) => intl.formatMessage(
  { id: 'report.schedule.details.membersFooter' },
  { ok: members.filter(m => m.eligibility === 'ok').length, total: members.length },
);
